module.exports = __webpack_public_path__ + "img/mjn_logo_poziome.8fa5867f.svg";